const getters = {
  device: state => state.app.device,
  token: state => state.user.token,
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  roles: state => state.user.roles
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js